import { Shield, Clock, Award, Sparkles, Star } from 'lucide-react';

export const mockData = {
  features: [
    {
      icon: <Shield className="w-8 h-8 text-white" />,
      title: "15+ Years Experience",
      description: "Trusted Sydney experts delivering premium epoxy solutions with proven expertise and reliability."
    },
    {
      icon: <Award className="w-8 h-8 text-white" />,
      title: "Premium Quality",
      description: "Industrial-grade materials and professional application ensuring lasting, beautiful results."
    },
    {
      icon: <Clock className="w-8 h-8 text-white" />,
      title: "Fast Turnaround",
      description: "Efficient service with minimal disruption. Most projects completed within 2-3 days."
    },
    {
      icon: <Sparkles className="w-8 h-8 text-white" />,
      title: "5-Year Workmanship Warranty",
      description: "Confidence in our work backed by comprehensive warranty on all epoxy installations."
    }
  ],

  services: [
    {
      title: "Garage Epoxy Flooring",
      description: "Transform your garage with durable, stunning epoxy floors that resist stains, chemicals, and wear.",
      image: "/images/gallery-1.jpg",
      features: [
        "Slip-resistant finish",
        "Easy to clean & maintain",
        "UV stable, won't yellow",
        "Multiple color options"
      ]
    },
    {
      title: "Commercial & Warehouse",
      description: "Heavy-duty epoxy solutions for high-traffic commercial and industrial environments.",
      image: "/images/gallery-2.jpg",
      features: [
        "Chemical resistant",
        "High traffic durability",
        "HACCP compliant",
        "Fast installation"
      ]
    },
    {
      title: "Metallic Epoxy",
      description: "Stunning metallic finishes that create unique, artistic 3D effects for modern spaces.",
      image: "/images/gallery-3.jpg",
      features: [
        "Unique patterns",
        "High-gloss finish",
        "Seamless application",
        "Gallery-worthy aesthetics"
      ]
    },
    {
      title: "Flake Epoxy Systems",
      description: "Decorative flake finishes offering superior durability with modern, textured appearance.",
      image: "/images/about-hero.jpg",
      features: [
        "Customizable colors",
        "Hide imperfections",
        "Anti-slip texture",
        "Long-lasting beauty"
      ]
    },
    {
      title: "Kitchen & Food Areas",
      description: "Food-safe, hygienic epoxy flooring ideal for commercial kitchens and preparation areas.",
      image: "/images/gallery-4.jpg",
      features: [
        "Food-grade certified",
        "Anti-microbial",
        "Easy sanitation",
        "Seamless surface"
      ]
    },
    {
      title: "Polished Concrete",
      description: "Modern, low-maintenance polished concrete solutions for residential and commercial spaces.",
      image: "/images/gallery-5.jpg",
      features: [
        "Natural look",
        "Eco-friendly",
        "Low maintenance",
        "Cost-effective"
      ]
    }
  ],

  gallery: [
    { url: "/images/gallery-1.jpg", title: "Residential Garage Transformation", category: "Residential", size: "large" },
    { url: "/images/gallery-3.jpg", title: "Metallic Epoxy Finish", category: "Commercial", size: "medium" },
    { url: "/images/gallery-2.jpg", title: "Warehouse Heavy-Duty Floor", category: "Industrial", size: "medium" },
    { url: "/images/gallery-5.jpg", title: "Polished Concrete Showroom", category: "Modern", size: "medium" },
    { url: "/images/gallery-6.jpg", title: "Decorative Metallic Pattern", category: "Decorative", size: "medium" },
    { url: "/images/gallery-4.jpg", title: "Commercial Kitchen Epoxy", category: "Food Grade", size: "large" }
  ],

  testimonials: [
    {
      name: "David Thompson",
      location: "Bondi, Sydney",
      review: "Absolutely thrilled with my new garage floor! The team was professional, punctual, and the finish exceeded expectations. Worth every penny. Highly recommend Alpha Epoxy to anyone in Sydney.",
      date: "2 months ago"
    },
    {
      name: "Sarah Chen",
      location: "Parramatta, Sydney",
      review: "We had our warehouse floor done and couldn't be happier. The surface is incredibly durable and looks fantastic. Great communication throughout the whole process. Highly recommend!",
      date: "3 weeks ago"
    },
    {
      name: "Michael Roberts",
      location: "North Shore, Sydney",
      review: "The metallic epoxy in our showroom is stunning. Everyone who visits comments on it. Professional service from start to finish. These guys really know their craft.",
      date: "1 month ago"
    }
  ],

  faqs: [
    {
      question: "How long does epoxy flooring last?",
      answer: "With proper installation and maintenance, epoxy floors can last 15-20 years or more. Our premium systems are designed for longevity and backed by our 5-Year Workmanship Warranty."
    },
    {
      question: "How long does installation take?",
      answer: "Most residential projects take 2-3 days including surface preparation, application, and curing time. Commercial projects vary based on size but we work efficiently to minimize downtime."
    },
    {
      question: "Is epoxy flooring suitable for Sydney's climate?",
      answer: "Absolutely! Our epoxy systems are UV-stable and designed specifically for Australian conditions. They won't yellow in the sun and handle temperature variations perfectly."
    },
    {
      question: "Can epoxy be applied over existing tiles?",
      answer: "Yes, in many cases we can apply epoxy over existing tiles, saving time and money on removal. We assess each surface to ensure proper adhesion and provide a thorough assessment before work begins."
    },
    {
      question: "What's included in the 35% off promotion?",
      answer: "Our limited-time offer includes 35% off all epoxy flooring services in Sydney. This covers materials, labor, and our standard warranty. Contact us today to claim this offer!"
    },
    {
      question: "How do I maintain my epoxy floor?",
      answer: "Epoxy floors are extremely low maintenance. Simply sweep or vacuum regularly and mop with warm water and a mild detergent as needed. Avoid harsh chemicals and abrasive cleaners. For commercial spaces, we recommend periodic professional cleaning to keep the finish looking its best."
    },
    {
      question: "Do you offer a warranty on your work?",
      answer: "Yes! All our epoxy installations come with a 5-Year Workmanship Warranty. We stand behind the quality of our work and materials. If any issues arise due to workmanship, we'll fix them at no additional cost."
    }
  ]
};